import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAppsKey } from '../../utils/keys';
export const useApps = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const appsKey = getAppsKey(variables);
    return useInfiniteQuery(appsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.app.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useApps.js.map